var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.02055 16.873728",
    role: "img",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6b7280",
    d: "M14.560943 0c-1.122351-.002-2.208724.10105-3.222542.3266C4.067451 1.94424-2.882631 9.13162 1.224289 10.7859c1.029665.41475 1.236001.29997 3.447335-1.91564 6.428607-6.44105 15.028419-6.5643 21.222994-.30386 2.739438 2.76857 4.510645 3.12976 5.038452 1.02681C32.040237 5.18101 22.417403.01322 14.560943-.0009zm.815971 4.71599c-5.947643.016-8.676527 8.83333-2.460315 11.66441v-.00052c.643238.29295 1.685748.48382 2.657719.48782l1.598869.006 1.431954-.8599c4.410388-2.64836 3.605321-9.53859-1.28571-11.00398-.677827-.20308-1.327244-.2957-1.942517-.29404zm3.456636 2.51819.547254.49506c.675945.61172.698367 1.25331.06356 1.8278-.636152.5757-1.182122.55303-1.747697-.0718-.606211-.66986-.445413-1.3626.429431-1.85363z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye_open.911f4e22d0e909f0c3260f08fe566d73.svg";
export { ForwardRef as ReactComponent };